import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Work from './components/Work';
import Reviews from './components/Reviews';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import Loader from './components/Loader';

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleHeroLoaded = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    // Fallback: hide loader after 3 seconds max
    const fallbackTimer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(fallbackTimer);
  }, []);

  return (
    <div className="App">
      {isLoading && <Loader />}
      {/* Hero component mounts immediately to start loading image */}
      <div style={{ visibility: isLoading ? 'hidden' : 'visible', position: isLoading ? 'absolute' : 'static', top: 0, left: 0, width: '100%' }}>
        <Navbar />
        <Hero onLoaded={handleHeroLoaded} />
        <Work />
        <Reviews />
        <Services />
        <Footer />
        <FloatingCTA />
      </div>
    </div>
  );
}